import { useState } from "react";

export function useTabs(tabs: string[], currentTab?: string) {
	const [activeTab, setTab] = useState(currentTab ?? tabs[0]);

	return {
		activeTab,
		tabs,
		setTab,
	};
}
